import { CANVAS_FLOAT_PRECISION } from 'helpers/Canvas';
import { createSelectOptions } from 'helpers/Object';

const CERTIFICATE_TAG = {
  ATTENDANCE: '*|ATTENDANCE|*',
  COURSE: '*|COURSE|*',
  ORGANIZER: '*|ORGANIZER|*',
  END_DATE: '*|END-DATE|*',
  CLASS_NAME: '*|CLASS-NAME|*',
  QR_CODE: '*|QR-CODE|*'
};

const CERTIFICATE_KEY = {
  ATTENDANCE: 'ATTENDANCE',
  COURSE: 'COURSE',
  ORGANIZER: 'ORGANIZER',
  END_DATE: 'END-DATE',
  CLASS_NAME: 'CLASS-NAME',
  QR_CODE: 'QR-CODE'
};

const CANVAS_BOARD_DIV_ID = 'canvas-editor__board';
const CANVAS_EDITOR_AREA_DIV_ID = 'canvas-editor__area';
const CERTIFICATE_EDITOR_AREA_PROPORTION = 1.41465;
const DEFINED_FONTS_FAMILY = {
  values: [
    'arial',
    'edwardian script itc',
    'georgia',
    'times new roman',
    'trebuchet ms',
    'verdana'
  ],
  labels: [
    'Arial',
    'Edwardian Script ITC',
    'Georgia',
    'Times New Roman',
    'Trebuchet MS',
    'Verdana'
  ]
};
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const FONT_SIZES = [6, 7, 8, 9, 10, 11, 12, 14, 18, 24, 30, 36, 48, 60, 72];

const TEXT_CONFIGS = {
  INITIAL_TEXT_WIDTH: 200,
  INITIAL_FONT_SIZE: 18,
  TAG_WIDTH: 370,
  PADDING_TEXT_POSITION: 10,
  MEDIUM_LETTER_WIDTH: 10,
  EDITING_BORDER_COLOR: '#f05827',
  INITIAL_TEXT_ALIGN: 'center',
  DEFINED_FONT_SIZES: createSelectOptions(
    FONT_SIZES,
    FONT_SIZES.map((size) => size.toString())
  ),
  DEFINED_FONTS_FAMILY: createSelectOptions(
    DEFINED_FONTS_FAMILY.values,
    DEFINED_FONTS_FAMILY.labels
  )
};

export {
  CANVAS_BOARD_DIV_ID,
  CANVAS_EDITOR_AREA_DIV_ID,
  CANVAS_FLOAT_PRECISION,
  CERTIFICATE_EDITOR_AREA_PROPORTION,
  TEXT_CONFIGS,
  CERTIFICATE_TAG,
  CERTIFICATE_KEY
};
